<template>
  <div class = 'third-menu' v-show = "menus.length">
      <div class = 'third-menu-content'>
          <Icon @click = '_clear' type="md-close" style = "position:absolute;right:10px;top:10px;cursor:pointer;" />
          <div class = "third-menu-title">{{title}}</div>
          <div @click = "_goto(item)" class = 'third-menu-item' :class = "{'third-menu-item-actived': item.actived}" v-for = '(item,index) in menus' :key = "index">{{item.title}}</div>
      </div>
  </div>
</template>

<script>
export default {
    computed:{
        menus(){
            return this.$store.state.main.menus.thirdMenus
        },
        title(){
            return this.$route.meta.title
        }
    },
    methods: {
        _goto(menuItem){
            this.$router.push({
                path: menuItem.path,
                query: {
                    id: menuItem.id
                },
                params: menuItem.params
            })
        },
        _clear(){
            this.$store.commit('main/menus/setThirdMenus',[])
        }
    }
}
</script>

<style scoped lang = "less">
.third-menu{
    height:100%;
    padding-right:10px;
    .third-menu-content{
        background:#fff;
        width:200px;
        height:100%;
        position: relative;
        .third-menu-title{
            font-size: 18px;
            padding: 24px 0 0 24px;
            color: #33344a;
            font-weight: 700;
        }
        .third-menu-item{
            height: 34px;
            line-height:34px;
            padding-left:24px;
            cursor:pointer;
            &:hover{
                color: #00b8c4;
                background: #f1f7f7;
            }
        }
        .third-menu-item-actived{
            color: #00b8c4;
            background: #f1f7f7;
        }
    }
}
</style>